import React from "react";
import "../Styles/Mvpm.css";

const Mvpm = () => {
  return (
    <>
      <section className="sectionMvpm">
        <div className="divMvpm">
          <h3 className="mvpmHeading">OUR MISSION</h3>
          <p className="mvpmText">
            <ul className="mvpmTextList">
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>
                  To deliver top-tier mechanical and electrical construction
                  services through innovative solutions
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i> To leverage advanced
                  technology and best practices to meet and exceed client
                  expectations
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>To foster a culture of
                  excellence and integrity in M&E construction, committed to
                  sustainable practices and continuous improvement for the
                  benefit of our clients and communities
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>To drive the future of M&E
                  construction with cutting-edge technology and a dedicated team
                </span>
              </li>
            </ul>
          </p>
        </div>

        <div className="divMvpm-1">
          <h3 className="mvpmHeading">OUR VISION</h3>
          <p className="mvpmText">
            <ul className="mvpmTextList">
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>
                  To be the leading name in integrated business, corporate &
                  financial management and construction services in Nigeria
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>To consistently add value by
                  providing quality & personalised solutions using the right
                  people, processes & technology
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i> We are committed to
                  providing and continually deploying innovative services to
                  consistently meet your business needs
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i> To harness innovative
                  technology and industry-leading practices to provide
                  efficient, cost-effective, and timely mechanical and
                  electrical construction solutions
                </span>
              </li>
            </ul>
          </p>
        </div>

        <div className="divMvpm">
          <h3 className="mvpmHeading">OUR METHODS</h3>
          <p className="mvpmText">
            <ul className="mvpmTextList">
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>
                  We prioritize flexibility and adaptability to meet client
                  needs and stay ahead of technological trends. For each
                  contract, we assemble specialized teams tailored to the
                  project's unique requirements
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i> We continuously conduct
                  research to identify and implement cost-effective solutions,
                  ensuring our projects are both economical and efficient
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i> We maintain rigorous
                  quality assurance measures to ensure the highest standards of
                  workmanship and reliability in all our projects
                </span>
              </li>
            </ul>
          </p>
        </div>

        <div className="divMvpm-1">
          <h3 className="mvpmHeading">OUR STRATEGY</h3>
          <p className="mvpmText">
            <ul className="mvpmTextList">
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>
                  <p> We identify our client's needs and develop their brief</p>
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>We consult associate
                  specialists when required
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i>
                  We research each project and current innovative practices
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i> We communicate each step of
                  our project
                </span>
              </li>
              <li>
                <span className="mvpmSpan">
                  <i class="fa-solid fa-circle"></i> We challenge ourselves to
                  ensure the best delivery
                </span>
              </li>
            </ul>
          </p>
        </div>
      </section>
    </>
  );
};

export default Mvpm;
